<template>
  <div class="announcement-wrapper">
    <h3 class="announcement-title">{{announcement.title}}<span class="announcement-subtitle">{{announcement.subTitle}}</span></h3>
    <div class="announcement-subheader">{{announcement.subHeader}}</div>
    <vue-markdown class="announcement-description" :anchor-attributes="anchorAttrs">{{announcement.description}}</vue-markdown>
    <div>
      <b-checkbox class="announcement-switch show-hand" switch v-model="switch1" :value="switch1">{{switch1Text}}</b-checkbox>
    </div>
    <div>
      <b-button class="announcement-button btn btn-sm btn-fill show-hand" variant="danger" @click="clickClose">{{buttonText}}</b-button>
    </div>

  </div>
</template>

<script>

  // https://github.com/miaolz123/vue-markdown
  import VueMarkdown from "vue-markdown";

  export default {
    name      : 'AnnouncementCard',
    components: {VueMarkdown},
    props     : {
      announcement: {type: Object, default: () => {}},
      switch1Text : {type: String, default: "Show on App Start"},
      buttonText  : {type: String, default: "Close"}
    },
    data() {
      return {
        switch1    : true,
        anchorAttrs: {
          target: '_blank',
          rel   : 'noopener noreferrer nofollow'
        }
      }
    },
    methods   : {
      clickClose() {
        this.$emit("button", {switch1: this.switch1});
      }
    }
  }
</script>

<!-- Removed "scoped" attribute since it breaks the CSS as created -->
<style lang="scss">

  .announcement-wrapper {
    background: #40455e;
    border: .05em solid #0F0F0F;
    padding: 1em;
    border-radius: .5em;
    text-align: left;
    height: 700px;
    width: 475px;

    /*Very simple scale -- could do a little better at some point*/
    @media only screen and (max-width: 425px) { width: 350px; }
    @media only screen and (max-width: 360px) { width: 320px; }
    @media only screen and (max-width: 320px) { width: 280px; }

    display: inline-block;
    -webkit-box-shadow: -10px 10px 15px 5px rgba(0,0,0,0.5);
    box-shadow: -10px 10px 15px 5px rgba(0,0,0,0.5);

    ::-webkit-scrollbar {
      width: .5em;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #6a6d7e;
      border-radius: 1em;
    }

    ::-webkit-scrollbar-thumb {
      background: #9c9da3;
      border-radius: 10px;
      cursor: pointer;
    }
  }

  .announcement-title {
    color: #9e9ea4;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .announcement-subtitle {
    color: #6a6d7e;
    font-size: .75em;
    font-style: italic;
    padding-left: .5em;
  }

  .announcement-subheader {
    color: #9e9ea4;
    font-size: .9em;
    padding-left: .5em;
    padding-bottom: .75em;
    margin-top: 0;
  }

  .announcement-description {
    background: #363a4f;
    color: #9c9da3;
    height: 84%;
    width: 100%;

    @media only screen and (max-width: 425px) { height:82%; }
    @media only screen and (max-width: 360px) { height:79%; }
    @media only screen and (max-width: 320px) { height:78%; }

    border-radius: .5em;
    padding: .5em;
    overflow-y: auto;

    -webkit-box-shadow: -2px 2px 20px 2px rgba(148,148,148,0.4);
    box-shadow: -2px 2px 20px 2px rgba(148,148,148,0.4);

    th {
      color: #6a6d7e;
    }

    code {
      color: #6a6d7e;
      /*color:white;*/
      /*background: #6a6d7e;*/
    }

    td, div, span {
      color: #9c9da3;
    }

    hr {
      background: #9c9da3;
    }
  }

  .announcement-switch {
    display: inline-block;
    margin-top: 1.5em;
    color: #9c9da3;
  }

  .announcement-button {
    display: inline-block;
    margin-top: -2.25em;
    float: right;
    border-radius: 1em;
    text-align: right;
    cursor: pointer;
  }


</style>
